import { render, staticRenderFns } from "./FarmScale.vue?vue&type=template&id=74ca1980&"
import script from "./FarmScale.vue?vue&type=script&lang=js&"
export * from "./FarmScale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports